export const SetJobsUrl = (data) => {
  console.log(data);
  return {
    type: "SETJOBSURL",
    payload: data
  };
}
